import FocusStyle from './Components/FocusStyle'
import FsLightbox from './Components/FsLightbox'

// Add focus behaviour
const focusStyle = new FocusStyle()
focusStyle.init()

// Add fslightbox
const fsLightbox = new FsLightbox()
fsLightbox.init()

// Add page-header functions
if (document.querySelector('.page-header')) {
  import('./Components/PageHeader')
    .then(({ PageHeader }) => {
      const pageHeader = new PageHeader()
      pageHeader.init()
    })
}

// Add main-navigation functions
if (document.querySelector('.main-navigation')) {
  import('./Components/MainNavigation')
    .then(({ MainNavigation }) => {
      const mainNavigation = new MainNavigation()
      mainNavigation.init()
    })
}

// Add button-burger functions
if (document.querySelector('.button-burger')) {
  import('./Components/ButtonBurger')
    .then(({ ButtonBurger }) => {
      const buttonBurger = new ButtonBurger()
      buttonBurger.init()
    })
}

// Add video box functions
if (document.querySelector('video')) {
  import('./Components/Video')
    .then(({ Video }) => {
      const video = new Video()
      video.init()
    })
}

// Add counter functions
if (document.querySelector('.counter')) {
  import('./Components/Counter')
    .then(({ Counter }) => {
      const counter = new Counter()
      counter.init()
    })
}

// Add quote slider functions
if (document.querySelector('.quote-slider')) {
  import('./Components/QuoteSlider')
    .then(({ QuoteSlider }) => {
      const quoteSlider = new QuoteSlider()
      quoteSlider.init()
    })
}

// Add blog list functions
if (document.querySelector('.blog-list-1')) {
  import('./Components/BlogList1')
    .then(({ BlogList1 }) => {
      const blogList1 = new BlogList1()
      blogList1.init()
    })
}

// Add image gallery functions
if (document.querySelector('.image-gallery')) {
  import('./Components/ImageGallery')
    .then(({ ImageGallery }) => {
      const imageGallery = new ImageGallery()
      imageGallery.init()
    })
}

// Add icon-box functions
if (document.querySelector('.icon-box')) {
  import('./Components/IconBox')
    .then(({ IconBox }) => {
      const iconBox = new IconBox()
      iconBox.init()
    })
}

// Init all parallax effects
if (document.querySelector('.parallax')) {
  import('./Components/Parallax')
    .then(({ Parallax }) => {
      const parallax = new Parallax()
      parallax.init()
    })
}

// Add teaser group functions
if (document.querySelector('.teaser-group .tiny-slider')) {
  import('./Components/TeaserGroup')
    .then(({ TeaserGroup }) => {
      const teaserGroup = new TeaserGroup()
      teaserGroup.init()
    })
}
